var _defs, _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHelixLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "LOGO",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 312.21 117",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #dd181d;\n      }\n\n      .cls-2 {\n        fill: #004e91;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299.35,117s-9.91-17.14-29.44-36.23l16.73-22.87h-25.24s-6.81,9.33-6.81,9.33c-25.17-20.09-59.3-38.84-105.12-37.99,40.41,4.08,67.29,22.08,95.25,51.35l-26.65,36.41h25.35l14.79-20.24c8.69,11.67,12.96,20.24,12.96,20.24h28.17Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M274.66,80.39c15.11,13.77,28.92,36.61,28.92,36.61h8.63s-11.26-20.22-33.35-42.35l-4.19,5.74Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M258.05,56.11c-22.8-16.7-48.07-28.04-84.77-28.04,34.62,4.3,59.09,17.06,80.6,33.77l4.17-5.73Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.57,6.31c-3.58-2.05-8.48-3.33-12.55-3.33-8.03,0-13.82,5.36-13.82,13.54s4.3,9.49,10.83,11.35c2.24.68,6.35,1.7,6.35,4.61s-2.6,4.06-5.07,4.06c-3.57,0-6.65-1.87-9.26-4.15l-4.46,8.44c4.11,2.88,9.04,4.59,14.14,4.59,4.01,0,8.21-1.15,11.35-3.79,3.17-2.72,4.14-6.81,4.14-10.87,0-6.49-4.31-9.33-9.88-10.98l-2.67-.8c-1.79-.6-4.64-1.51-4.64-3.88,0-2.24,2.56-3.34,4.49-3.34,2.56,0,5.01,1.06,6.9,2.65l4.15-8.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M38.15,0v44.36h9.68v-14.08c0-3.19,1.2-6.5,5.05-6.5s4.36,3.31,4.36,6.5v14.08h9.67v-16.8c0-6.94-3.33-11.51-10.23-11.51-3.8,0-6.5,1.38-8.72,4.37h-.13V0h-9.68"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M100.99,31.26c0-9.36-5.51-15.21-14.98-15.21-8.88,0-15.08,5.48-15.08,14.64s6.75,14.54,15.79,14.54c6.2,0,12.31-2.91,13.86-9.36h-9.29c-1.08,1.82-2.55,2.51-4.65,2.51-3.97,0-6.03-2.15-6.03-6.11h20.38v-1M80.77,26.65c.57-2.8,2.91-4.31,5.75-4.31,2.61,0,4.99,1.7,5.46,4.31h-11.21Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 105.12,
    width: 9.66,
    height: 44.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 119.66,
    width: 9.66,
    height: 44.36
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M47.99,79.18h-19.66v-21.28H0l6.29,7.94v51.16h22.05v-22.54h19.66v22.54h22.04v-59.09h-22.04v21.28ZM99.46,57.9h-19.34v59.09h49.33v-14.37h-27.27v-7.98h26.01v-14.36h-26.01v-8.01h27.27v-14.37h-29.98ZM160.58,57.9h-22.04v59.09h44.2v-14.37h-22.16v-44.73ZM189.33,57.9v59.09h22.04v-59.09h-22.04Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelixLogo);
export default __webpack_public_path__ + "static/media/Helix Logo.c06f26f2e304883f951f926d4ce9c09b.svg";
export { ForwardRef as ReactComponent };